import download from 'downloadjs'
import { FileImageUrlOption } from 'types/files/FileImageType'

export function urlToBlob(url: string) {
  return fetch(url).then((response) => response.blob())
}

export async function downloadImages(data: FileImageUrlOption[]) {
  data.forEach(async (d) => {
    const blob = await urlToBlob(d.url)
    download(blob, d.name, 'image/png,image/jpg')
  })
}

export function getFileSize(byteSize: number, decimals = 2) {
  if (byteSize === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB']

  const i = Math.floor(Math.log(byteSize) / Math.log(k))

  return `${parseFloat((byteSize / k ** i).toFixed(dm))} ${sizes[i]}`
}
